











































































































































































import Vue, { PropType } from "vue"
import { vueWith } from "./../vueWith"
import { Text } from "./../../common/text"
import { MemberNoticeEnabledDispModel } from "../../model/MemberNoticeEnabledDispModel"


/** 外部公開用 親から呼び出すことを想定 */
export interface MemberNoticeTableComponentMethods {
  /** データ読み込み後テーブルを有効化  */
  mountData: () => void
}


/**
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: { // 親から渡される値。変更不可
    /** dataに対応するインデックス viewとやり取り時に変換が必要 */
    index: Number,
    placeholder: String,
    data: Array as PropType<MemberNoticeEnabledDispModel[]>,
  },
  watch: {
    //
  },
  data() {
    return {
      dispData: [] as MemberNoticeEnabledDispModel[],

      mailAllEnabled: false,
      chatworkAllEnabled: false,
      lineworksAllEnabled: false,
      slackAllEnabled: false,
      teamsAllEnabled: false,


      searchKeyword: "",
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    // this.filter("")
  },

  mounted: function mount() {
    //
  },

  methods: {

    searchuser(event: InputEvent) {
      // console.log(event)
      this.dispData = []
      this.data.forEach((datum) => {
        const isMatchName = datum.name.indexOf(this.searchKeyword) !== -1
        const isMatchKana = Text.convertTextFullToHalf(datum.kana).indexOf(Text.convertTextFullToHalf(this.searchKeyword)) !== -1
        const isMatchMailAddress = datum.mailAddress.indexOf(this.searchKeyword) !== -1
        if (isMatchName || isMatchMailAddress || isMatchKana) {
          this.dispData.push(datum)
        }
      })
    },

    mailAllChange(event: InputEvent) {
      const checkbox = event.target as HTMLInputElement
      // console.log(checkbox.checked)
      this.dispData.forEach((datum) => {
        datum.mailEnabled = checkbox.checked
      })
    },

    chatworkAllChange(event: InputEvent) {
      const checkbox = event.target as HTMLInputElement
      // console.log(checkbox.checked)
      this.dispData.forEach((datum) => {
        datum.chatworkEnabled = checkbox.checked
      })
    },

    lineworksAllChange(event: InputEvent) {
      const checkbox = event.target as HTMLInputElement
      // console.log(checkbox.checked)
      this.dispData.forEach((datum) => {
        datum.lineworksEnabled = checkbox.checked
      })
    },

    slackAllChange(event: InputEvent) {
      const checkbox = event.target as HTMLInputElement
      // console.log(checkbox.checked)
      this.dispData.forEach((datum) => {
        datum.slackEnabled = checkbox.checked
      })
    },

    teamsAllChange(event: InputEvent) {
      const checkbox = event.target as HTMLInputElement
      // console.log(checkbox.checked)
      this.dispData.forEach((datum) => {
        datum.teamsEnabled = checkbox.checked
      })
    },

    // 子から呼ばれる ---------------------------------------------

    mountData() {
      // console.log("mounted")

      let mailAllEnabled = true
      let chatworkAllEnabled = true
      let lineworksAllEnabled = true
      let slackAllEnabled = true
      let teamsAllEnabled = true
      this.data.forEach((datum) => {
        if (!datum.mailEnabled) {
          mailAllEnabled = false
        }
        if (!datum.chatworkEnabled) {
          chatworkAllEnabled = false
        }
        if (!datum.lineworksEnabled) {
          lineworksAllEnabled = false
        }
        if (!datum.slackEnabled) {
          slackAllEnabled = false
        }
        if (!datum.teamsEnabled) {
          teamsAllEnabled = false
        }
        this.dispData.push(datum)
      })
      this.chatworkAllEnabled = chatworkAllEnabled
      this.mailAllEnabled = mailAllEnabled
      this.lineworksAllEnabled = lineworksAllEnabled
      this.slackAllEnabled = slackAllEnabled
      this.teamsAllEnabled = teamsAllEnabled
      // console.log(this.dispData)
    },

  },
})

